import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'State Code',
    field: 'code',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Full Name',
    field: 'name',
    displayValue: row => `${row.name} ${row.country ? row.country.name : ''}`.trim(),
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Country',
    field: 'country',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      type: 'one',
      localKey: 'countryId',
      fk: 'id',
      namespace: 'country',
      filterIs: 'text-filter'
    })
  })
  //   createColumn({
  //     label: 'State Code',
  //     field: 'code',
  //     section: 'Info',
  //     sort: numberSort,
  //     component: {
  //       req: false,
  //       is: 'q-select',
  //       props: {
  //         options: stateOptions,
  //         filter: true,
  //         autofocusFilter: true
  //       }
  //     }
  //   }),
].concat(defaultColumns)
